import React from "react";
import {
  CheckboxWrapper,
  ErrorDiv,
  FlexDiv,
  SubTitle,
  InputHeader,
  InputWrapper,
  SendUpdatesText,
  StyledCheckbox,
  StyledInput,
  SubmitButton,
} from "../newsletterStyles";

const NewsletterConsent = ({
  handleInputChange,
  handleSubmit,
  submitError,
  newsletterChecked,
  updatesChecked,
  emailError,
  secondary,
}) => {
  return (
    <>
      {!secondary ? (
        <SubTitle secondary={secondary}>
          Stay informed of aviation technology developments that could impact
          your operations.
        </SubTitle>
      ) : null}
      <form method="post" onSubmit={(event) => this.handleSubmit(event)}>
        <InputWrapper>
          <InputHeader secondary={secondary}>Work email address</InputHeader>
          <StyledInput
            onChange={(e) => handleInputChange(e.target.value, "email")}
            error={emailError}
            onClick={(e) => e.stopPropagation()}
            name="email"
            secondary={secondary}
          />
          {emailError ? (
            <ErrorDiv secondary={secondary}>{emailError}</ErrorDiv>
          ) : null}
        </InputWrapper>
        <CheckboxWrapper>
          <FlexDiv>
            <StyledCheckbox
              type="checkbox"
              onChange={() =>
                handleInputChange(!newsletterChecked, "newsletter")
              }
              checked={newsletterChecked}
              onClick={(e) => e.stopPropagation()}
            />
            <SendUpdatesText secondary={secondary}>
              Receive our quarterly newsletter.
            </SendUpdatesText>
          </FlexDiv>
          <FlexDiv>
            <StyledCheckbox
              type="checkbox"
              onChange={() => handleInputChange(!updatesChecked, "updates")}
              checked={updatesChecked}
              onClick={(e) => e.stopPropagation()}
            />
            <SendUpdatesText secondary={secondary}>
              Receive product updates, customer case studies and webinar
              invites.
            </SendUpdatesText>
          </FlexDiv>
        </CheckboxWrapper>

        <SubmitButton
          onClick={(e) => {
            e.stopPropagation();
            handleSubmit(e);
          }}
        >
          Sign up to our newsletter
        </SubmitButton>
        {submitError ? (
          <ErrorDiv secondary={secondary}>{submitError}</ErrorDiv>
        ) : null}
      </form>
    </>
  );
};

export default NewsletterConsent;
